import { GetControlPanelDataParams } from "../../types/controlPanelTypes";
import { Fund } from "../../enums/BusinessLogic";

export const initialFilters: GetControlPanelDataParams = {
  global_params: {
    portfolio_index_id: [],
    scope_id: null,
    fund_type: Fund.INDEX,
  },
  security_types_ratios: {},
  top_contributors_rank: {},
  ghg_emissions_by_portfolio: {},
  carbon_pathway_by_portfolio: {},
};
